/**
 * Snelkoppelingen naar ledenregisters van branchverenigingen.
 *
 * `registration_organization` in de screening is een vrije combinatiestring
 * (bijv. 'NOBCO / StiR', 'BIG / NIP / SKJ', 'RNVC (Crov®-register)').
 * resolveRegisterLinks() matcht bekende tokens in die string en geeft
 * 0..n directe links terug zodat de admin het register met één klik opent.
 * Onbekende tokens (bijv. 'LVR', 'Beroepsvereniging') leveren geen link op.
 */

export interface RegisterLink {
  label: string;
  url: string;
  /** Afwijkend match-token als label ≠ tekst in de organisatie-string */
  match?: string;
}

// Token → register-URL. Tokens worden case-insensitief op woordgrens gematcht.
const REGISTER_URLS: RegisterLink[] = [
  { label: 'Verslavingskunde NL', match: 'Verslavingskunde', url: 'https://www.verslavingskundenederland.nl/' },
  { label: 'Registerplein', url: 'https://www.registerplein.nl/registers/' },
  { label: 'NVVBS', url: 'https://www.nvvbs.nl/aangesloten-coaches/' },
  { label: 'Nibud', url: 'https://www.nibud.nl/' },
  { label: 'NVVK', url: 'https://www.nvvk.nl/' },
  { label: 'NVvA', url: 'https://www.arbeidshygiene.nl/' },
  { label: 'Noloc', url: 'https://www.noloc.nl/vind-een-loopbaanprofessional' },
  { label: 'NOBCO', url: 'https://www.nobco.nl/coach-gids' },
  { label: 'StiR', url: 'https://stir.nu/register/' },
  { label: 'NVPA', url: 'https://nvpa.org/zoek-een-therapeut' },
  { label: 'RNVC', url: 'https://rnvc.nl/' },
  { label: 'KIWA', url: 'https://www.kiwa.com/nl/nl/' },
  { label: 'MfN', url: 'https://mfnregister.nl/zoek-een-mediator/' },
  { label: 'SRA', url: 'https://www.register-arbeidsdeskundigen.nl/' },
  { label: 'BIG', url: 'https://zoeken.bigregister.nl/' },
  { label: 'SKJ', url: 'https://skjeugd.nl/register/' },
  { label: 'NIP', url: 'https://psynip.nl/vind-een-psycholoog/' },
  { label: 'LVV', url: 'https://www.lvvv.nl/' },
  { label: 'V&VN', url: 'https://www.venvn.nl/' },
];

/**
 * Geef alle register-links die in de organisatie-string voorkomen.
 * Matcht op woordgrens zodat 'NIP' niet matcht binnen bijv. 'SNIPPER'.
 */
export function resolveRegisterLinks(organization: string | null | undefined): RegisterLink[] {
  if (!organization) return [];

  const links: RegisterLink[] = [];
  for (const entry of REGISTER_URLS) {
    // Woordgrens-match, case-insensitief; regex-specials in het token escapen.
    const token = entry.match ?? entry.label;
    const escaped = token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const pattern = new RegExp(`(^|[^A-Za-z])${escaped}([^A-Za-z]|$)`, 'i');
    if (pattern.test(organization)) {
      links.push(entry);
    }
  }
  return links;
}
